import { useTranslation } from 'react-i18next';
import { formatedDate } from 'utils/general';

import { ISettlements } from '@/modules/Settlements/types';
import { formatAccountingPeriod } from '@/shared/components/molecules/CreateSettlement/logic';
import { useStore } from '@/shared/hooks/context/createGenericContext';

export const useWorkerSettlemetHelper = () => {
  const {
    i18n: { language },
  } = useTranslation('common');
  const [selectedAsset] = useStore((store) => store.asset);

  const getWorkerSettlementCardData = (
    settlement: ISettlements.IWorkerSettlementSchema
  ) => {
    const dateCreated = settlement.creationDate
      ? formatedDate(settlement.creationDate, 'dd MMM yyyy', language)
      : '-';
    const issuingDate = settlement.issuanceDate
      ? formatedDate(settlement.issuanceDate, 'dd MMM yyyy', language)
      : '-';

    return {
      worker: settlement.workerName,
      'settlement-number': settlement.id,
      'crew-name': settlement.crewName,
      'accounting-period': formatAccountingPeriod({
        startDate: settlement.startDate,
        endDate: settlement.endDate,
        language,
      }),
      ...(settlement.issuanceDate
        ? {
            'issuing-date': issuingDate,
          }
        : {
            'Date Created': dateCreated,
          }),
      total: `${settlement.totalAmount ?? 0} ${selectedAsset?.currency}`,
    };
  };
  return {
    getWorkerSettlementCardData,
  };
};
